import {
    type OptionsDefs,
    arrayOf,
    boolean,
    callbackDefs,
    callbackOf,
    commonSeriesOptionsDefs,
    commonSeriesThemeableOptionsDefs,
    constant,
    fillOptionsDef,
    labelCollisionFitOptionsDefs,
    labelOrientationDef,
    labelPlacementStyleDefs,
    lineDashOptionsDef,
    multiSeriesHighlightOptionsDef,
    number,
    positiveNumber,
    required,
    seriesLabelOptionsDefs,
    shadowOptionsDefs,
    shapeHighlightOptionsDef,
    string,
    strokeOptionsDef,
    tooltipOptionsDefs,
    union,
    unionOrArray,
} from 'ag-charts-core';
import type {
    AgHistogramSeriesOptions,
    AgHistogramSeriesStyle,
    AgHistogramSeriesThemeableOptions,
} from 'ag-charts-types';

const histogramStyler = callbackDefs<AgHistogramSeriesStyle>({
    ...fillOptionsDef,
    ...strokeOptionsDef,
    ...lineDashOptionsDef,
    cornerRadius: positiveNumber,
});

export const histogramSeriesThemeableOptionsDef: OptionsDefs<AgHistogramSeriesThemeableOptions> = {
    showInMiniChart: boolean,
    cornerRadius: positiveNumber,
    styler: histogramStyler,
    itemStyler: histogramStyler,
    label: {
        ...seriesLabelOptionsDefs,
        ...labelCollisionFitOptionsDefs,
        ...labelPlacementStyleDefs,
        placement: unionOrArray('inside-center', 'inside-start', 'inside-end', 'outside-start', 'outside-end'),
        spacing: positiveNumber,
        orientation: labelOrientationDef,
    },
    tooltip: tooltipOptionsDefs,
    shadow: shadowOptionsDefs,
    ...commonSeriesThemeableOptionsDefs,
    ...fillOptionsDef,
    ...strokeOptionsDef,
    ...lineDashOptionsDef,
    highlight: multiSeriesHighlightOptionsDef(shapeHighlightOptionsDef, shapeHighlightOptionsDef),
    areaPlot: boolean,
    aggregation: union('count', 'sum', 'mean'),
    bins: arrayOf(arrayOf(number)),
    binCount: positiveNumber,
};

export const histogramSeriesOptionsDef: OptionsDefs<AgHistogramSeriesOptions> = {
    ...commonSeriesOptionsDefs,
    ...histogramSeriesThemeableOptionsDef,
    type: required(constant('histogram')),
    xKey: required(string),
    yKey: string,
    xKeyAxis: string,
    yKeyAxis: string,
    xName: string,
    yName: string,
    getItemId: callbackOf(string),
};
